import React, { useContext, useEffect } from "react";
import SoldOut from "./TicketButtons/SoldOut";
import Expired from "./TicketButtons/Expired";
import Register from "./TicketButtons/Register";
import ComingSoon from "./TicketButtons/ComingSoon";
import JoinWaitlist from "./TicketButtons/JoinWaitlist";
import Link from "next/link";
import moment from "moment";
import eventContext from "../../../../contexts/EventContext";
import ReactHtmlParser from "react-html-parser";
import GetCurrency from "../../../../helpers/services";
import ReadMore from "../../../../components/ReadMoreText";
import EventTicketButton from "./TicketButtons/Approval";
import Approval from "./TicketButtons/Approval";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { isOnDiscount, discountContentByCondition, hasGroupDiscountOffer } from "../../../../helpers/common";
import TicketCard from "../../GeneralComponents/TicketCard";
import { useMediaQuery } from "react-responsive";
import { CurrencyWithAmount } from "../../../../helpers/utils";

const TicketInfo = ({ data, eventUrl, newQuery, couponCode, groupDiscounts }) => {
	const { eventData } = useContext(eventContext);
	const discount_conditon = [1, 2];
	//Dont show ticket venue if it is same as event venue
	const showVenue = data.venue && eventData.venue === data.venue ? false : true;

	let ticket_start_timestamp = data.start_timestamp;
	let ticket_end_timestamp = data.end_timestamp;
	let event_end_timestamp = `${eventData.end_date} ${eventData.end_time}`;

	const date = {
		start_month: moment.utc(ticket_start_timestamp).local().format("MMM Do"),
		end_month: moment.utc(ticket_end_timestamp).local().format("MMM Do"),
		start_day: moment.utc(ticket_start_timestamp).local().format("ddd"),
		end_day: moment.utc(ticket_end_timestamp).local().format("ddd"),
		start_year: moment.utc(ticket_start_timestamp).local().format("YYYY"),
		end_year: moment.utc(ticket_end_timestamp).local().format("YYYY"),
		start_time: moment.utc(ticket_start_timestamp).local().format("HH:mm"),
		end_time: moment.utc(ticket_end_timestamp).local().format("HH:mm")
	};

	const handleMediaQueryChange = matches => {
		smallerScreen = matches;
		// matches will be true or false based on the value for the media query
	};
	let smallerScreen = useMediaQuery({ maxWidth: 535 }, undefined, handleMediaQueryChange);

	const buttonType = ticket => {
		var todaysTime = moment().valueOf();
		// convert utc to local
		let ticketStartTime = moment.utc(ticket_start_timestamp).local().valueOf();
		let ticketEndTime = moment.utc(ticket_end_timestamp).local().valueOf();
		let eventEndTime = moment.utc(event_end_timestamp).local().valueOf();

		switch (true) {
			case todaysTime > eventEndTime:
				return <Expired />;
			case todaysTime > ticketEndTime:
				return <SoldOut />;
			case todaysTime > ticketEndTime && ticket.sold_out:
				return <SoldOut />;
			case (ticket.sold_out && !ticket.waitlist_enabled) ||
				(ticket.remaining_count <= 0 && !ticket.waitlist_enabled):
				return <SoldOut />;
			case ticketStartTime > todaysTime:
				return <ComingSoon />;
			case ticket.approval_enabled:
				return (
					<Link
						href={{
							pathname: `/checkout/${eventUrl}`,
							query: {
								ticketId: `${ticket.ticket_id}`,
								...(ticket.teamBasedEvent && { teamRegType: 0 }),
								...(couponCode && { selectedCode: couponCode }),
								...newQuery
							}
						}}
					>
						<div style={{ textDecoration: "none" }}>
							<Approval
								btnText={
									smallerScreen
										? ticket.ticket_type === 3
											? "Donate"
											: "Register"
										: "Register Your Interest"
								}
							/>
						</div>
					</Link>
				);
			case !ticket.sold_out && ticket.remaining_count <= 0 && ticket.waitlist_enabled:
				return (
					<Link
						href={{
							pathname: `/checkout/${eventUrl}`,
							query: {
								ticketId: `${ticket.ticket_id}`,
								...(ticket.teamBasedEvent && { teamRegType: 0 }),
								...(couponCode && { selectedCode: couponCode }),
								...newQuery
							}
						}}
					>
						<div style={{ textDecoration: "none" }}>
							<JoinWaitlist />
						</div>
					</Link>
				);
			case ticket.sold_out && ticket.waitlist_enabled:
				return (
					<Link
						href={{
							pathname: `/checkout/${eventUrl}`,
							query: {
								ticketId: `${ticket.ticket_id}`,
								...(ticket.teamBasedEvent && { teamRegType: 0 }),
								...(couponCode && { selectedCode: couponCode }),
								...newQuery
							}
						}}
					>
						<div style={{ textDecoration: "none" }}>
							<JoinWaitlist />
						</div>
					</Link>
				);
			case ticketStartTime < ticketEndTime && !ticket.sold_out:
				return (
					<Link
						href={{
							pathname: `/checkout/${eventUrl}`,
							query: {
								ticketId: `${ticket.ticket_id}`,
								...(ticket.teamBasedEvent && { teamRegType: 0 }),
								...(couponCode && { selectedCode: couponCode }),
								...newQuery
							}
						}}
					>
						<div style={{ textDecoration: "none" }}>
							<Register btnText={ticket.ticket_type === 3 ? "Donate" : "Register"} />
						</div>
					</Link>
				);
			default:
				break;
		}
	};

	const hasGroupDiscount =
		!data.is_free &&
			hasGroupDiscountOffer(groupDiscounts, data.ticket_id)
			? true
			: false;


	const findMaxDiscount = (ticket, groupDiscount) => {
		const { ticket_id, totalSelected, ticket_price } = ticket;

		let maxDiscount = 0;
		let maxDiscountType = 0; // 1 for flat, 2 for percentage
		let discountVal = 0;

		groupDiscount.forEach(discount => {
			const {
				attached_ticket_ids,
				minimum_tickets,
				maximum_tickets,
				coupon_type,
				discount: discountValue
			} = discount;

			// Check if the ticket ID is attached to the discount and if the totalSelected is within the min and max ticket range
			if (
				attached_ticket_ids.includes(ticket_id) && minimum_tickets === 0
			) {
				let calculatedDiscount = 0;

				// Calculate the discount based on coupon type
				if (coupon_type === 2) {
					calculatedDiscount = ticket_price - ((discountValue / 100) * ticket_price);
				} else if (coupon_type === 1) {
					calculatedDiscount = discountValue;
				}

				discountVal = discountValue

				// Check if the calculated discount is greater than the current maxDiscount
				if (calculatedDiscount > maxDiscount) {
					maxDiscount = calculatedDiscount;
					maxDiscountType = coupon_type;
				}
			}
		});

		// Calculate the total discount and final price
		let totalDiscount = 0;

		if (maxDiscountType === 2) {
			totalDiscount = (ticket_price - maxDiscount);
		} else if (maxDiscountType === 1) {
			totalDiscount = maxDiscount;
		}

		return { totalDiscount, maxDiscountType, discountVal };
	};

	const showPrice = ticket => {
		const ticketPrice = ticket.ticket_price;
		// checking if the automatic_discount_rule have minimun ticket purchase is 0
		let hasMinimumTicketsZero =
			ticket.automatic_discount_rules &&
			ticket.automatic_discount_rules.some(rule => rule.minimum_tickets === 0);

		let index;
		if (hasMinimumTicketsZero) {
			index = ticket.automatic_discount_rules.findIndex(rule => rule.minimum_tickets === 0);
		}

		let { totalDiscount = 0, maxDiscountType = 0, discountVal = 0 } = {};

		if (hasGroupDiscount) {
			({ totalDiscount, maxDiscountType, discountVal } = findMaxDiscount(ticket, groupDiscounts));
		}


		if (ticket.discount) {
			return (
				<>
					<span className="ms-1 d-inline-block">
						{ticket.final_price === 0 ? (
							"FREE"
						) : (
							<CurrencyWithAmount
								currencyName={ticket.currency_name}
								number={ticket.final_price}
							/>
						)}
					</span>
					<span className="ms-1 currency_number_strikeThrough strike">
						<CurrencyWithAmount
							fontSize={"14px"}
							currencyName={ticket.currency_name}
							number={ticketPrice}
						/>
					</span>
					<style jsx>{`
							.strike {
								text-decoration: line-through;
								// text-decoration-thickness: 2px;
								opacity: 0.6;
							}
							.currency_number_strikeThrough {
								font-size: 14px !important;
								line-height: 38px;
								vertical-align: text-top;
							}
						`}</style>
				</>
			);
		} else if (
			hasMinimumTicketsZero &&
			ticket.automatic_discount_rules[index].discount_type == 1
		) {
			return (
				<>
					<span className="ms-1 d-inline-block">
						<CurrencyWithAmount
							currencyName={ticket.currency_name}
							number={Math.round(
								ticketPrice - ticket.automatic_discount_rules[index].discount_value
							)}
						/>
					</span>
					<span className="ms-1 currency_number_strikeThrough strike">
						<CurrencyWithAmount
							fontSize={"14px"}
							currencyName={ticket.currency_name}
							number={ticketPrice}
						/>
						<style jsx>{`
							.strike {
								text-decoration: line-through;
								// text-decoration-thickness: 2px;
								opacity: 0.6;
							}
							.currency_number_strikeThrough {
								font-size: 14px !important;
								line-height: 38px;
								vertical-align: text-top;
							}
						`}</style>
					</span>
				</>
			);
		} else if (
			hasMinimumTicketsZero &&
			ticket.automatic_discount_rules[index].discount_type == 2
		) {
			return (
				<>
					<span className="ms-1 d-inline-block">
						<CurrencyWithAmount
							currencyName={ticket.currency_name}
							number={Math.round(
								ticketPrice -
								ticketPrice *
								(ticket.automatic_discount_rules[index].discount_value /
									100)
							)}
						/>
					</span>
					<span className="ms-1 currency_number_strikeThrough strike">
						<CurrencyWithAmount
							fontSize={"14px"}
							currencyName={ticket.currency_name}
							number={ticketPrice}
						/>
						<style jsx>{`
							.strike {
								text-decoration: line-through;
								// text-decoration-thickness: 2px;
								opacity: 0.6;
							}
							.currency_number_strikeThrough {
								font-size: 14px !important;
								line-height: 38px;
								vertical-align: text-top;
							}
						`}</style>
					</span>
				</>
			);
		} else if (hasGroupDiscount && totalDiscount) {
			return (
				<>
					<span className="ms-1 d-inline-block">
						<CurrencyWithAmount
							currencyName={ticket.currency_name}
							number={
								ticketPrice - totalDiscount
							}
						/>
					</span>
					<span className="ms-1 currency_number_strikeThrough strike">
						<CurrencyWithAmount
							fontSize={"14px"}
							currencyName={ticket.currency_name}
							number={ticketPrice}
						/>
					</span>
					<div className="mb-2 mb-lg-0 save_group_discount_tag d-flex align-items-center justify-content-center">
						<div className="save_group_discount_text">
							{
								maxDiscountType === 2 ?
									<span>Save{" "}
										<span>
											<CurrencyWithAmount
												fontSize={"12px"}
												currencyName={ticket.currency_name}
												number={totalDiscount}
											/>{` (${discountVal}%)`}
										</span>
									</span>
									:
									<span>Save{" "}
										<span>
											<CurrencyWithAmount
												fontSize={"12px"}
												currencyName={ticket.currency_name}
												number={totalDiscount}
											/>
										</span>
									</span>
							}
						</div>
					</div>
					<style jsx>{`
						.strike {
							text-decoration: line-through !important;
							// text-decoration-thickness: 2px !important;
							opacity: 0.6 !important;
						}

						.save_group_discount_tag {
							width: fit-content;
							min-height: 22px;
							padding: 0px 9px 0px 9px;
							border-radius: 15px;
							background: #FDB14B;
						}
							
						.save_group_discount_text {
							font-family: Prompt;
							font-size: 12px;
							font-weight: 500;
							line-height: 21px;
							letter-spacing: 1px;
							color: #FFFFFF;
						}
						.currency_number_strikeThrough {
							font-size: 14px !important;
							line-height: 38px;
							vertical-align: text-top;
						}
					`}</style>
				</>
			);
		} else {
			return (
				<span className="ms-1 d-inline-block">
					<CurrencyWithAmount currencyName={ticket.currency_name} number={ticketPrice} />
				</span>
			);
		}
	};

	const getTicketStatus = ticket => {
		var todaysTime = moment().valueOf();
		// convert utc to local
		let ticketStartTime = moment.utc(ticket_start_timestamp).local().valueOf();
		let ticketEndTime = moment.utc(ticket_end_timestamp).local().valueOf();
		let eventEndTime = moment.utc(event_end_timestamp).local().valueOf();

		switch (true) {
			case todaysTime > ticketEndTime || todaysTime > eventEndTime:
				return "Expired";
			case todaysTime > ticketEndTime:
				return "Sold Out";
			case (ticket.sold_out && !ticket.waitlist_enabled) ||
				(ticket.remaining_count <= 0 && !ticket.waitlist_enabled):
				return "Sold Out";
			case ticketStartTime > todaysTime:
				return "Coming Soon";
			case ticket.approval_enabled:
				return "Approval";
			case !ticket.sold_out && ticket.remaining_count <= 0 && ticket.waitlist_enabled:
				return "Waitlist";
			case ticket.sold_out && ticket.waitlist_enabled:
				return "Waitlist";
			case ticketStartTime < ticketEndTime && !ticket.sold_out:
				return "Register";
			default:
				break;
		}
	};

	const getRemainingText = count => {
		switch (true) {
			case count === 3:
				return "Only 3 tickets left!";

			case count === 2:
				return "Only 2 tickets left!";

			case count === 1:
				return "Only 1 ticket left!";

			case count <= 10:
				return "Only few tickets left!";

			case count <= 0:
				return null;

			default:
				return null;
		}
	};

	const getTZ = (date, tz) => {
		return moment.tz(`${date}`, tz).format("z");
	};

	var todaysTime = moment().valueOf();
	// convert utc to local
	let ticketStartTime = moment.utc(ticket_start_timestamp).local().valueOf();

	return (
		<>
			<TicketCard
				data={data}
				hasGroupDiscount={hasGroupDiscount}
				discountContent={
					hasGroupDiscount &&
					groupDiscounts
						.filter(item => discount_conditon.includes(item.coupon_type))
						.map((item, index) => (
							<div key={index}>{discountContentByCondition(item, data)}</div>
						))
				}
				ticketStartTime={ticketStartTime}
				todaysTime={todaysTime}
				showVenue={showVenue}
				ticketStatus={
					getTicketStatus(data) === "Register" && getRemainingText(data.remaining_count)
				}
				ticketPrice={showPrice(data)}
				buttonType={buttonType(data)}
				getTZ={getTZ}
				eventData={eventData}
				groupDiscounts={groupDiscounts}
			/>
			<style>
				{`.strike{
                    text-decoration: line-through;
                    text-decoration-thickness: 2px;
                    opacity: 0.6;
                }`}
			</style>
		</>
	);
};

export default TicketInfo;
